import axios from 'axios'
import * as types from '@/actions/types'
import constants from '@/constants'

export function setOpen(bool) {
  return {
    type: types.NAV_SET_OPEN,
    setOpen: bool,
  }
}

export function setCompact(bool) {
  return {
    type: types.NAV_SET_COMPACT,
    setCompact: bool,
  }
}

export function getMainMenu() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_MAIN_MENU)
        .then((response) => {
          if (Array.isArray(response.data)) {
            dispatch({
              type: types.NAV_GET_MAIN,
              data: response.data,
            })
            const { loading } = getState()
            dispatch({
              type: types.LOADING_SET_INC_STATUS,
              setIncrementalStatus: loading.incremental + 1,
            })
            resolve(response)
          }
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getMobileMenu() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_MOBILE_MENU)
        .then((response) => {
          dispatch({
            type: types.NAV_GET_MOBILE,
            data: response.data,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getExtraMenu() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_EXTRA_MENU)
        .then((response) => {
          dispatch({
            type: types.NAV_GET_EXTRA,
            data: response.data,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getMenu(name) {
  const content = []
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_MENU}/${name}`)
        .then((response) => {
          content[name] = response.data
          dispatch({
            type: types.NAV_GET_GENERIC,
            data: content,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
